import { Card } from '@/components/Card';

export function ReportCardSkeleton() {
    return <Card loading />;
}
